module.exports = __webpack_public_path__ + "static/media/correct.8edd56df.mp3";